export enum BannerType {
  ANNOUNCEMENT = 'announcement',
  ERROR = 'error',
  NOTIFICATION = 'notification'
}
